import axios from 'axios';
import localStorage from 'local-storage';
import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Card, Alert, Spinner } from 'react-bootstrap';
import { BASE_URL, HEADER_OPTIONS } from './lib/basic';
import { openNotificationWithIcon } from "./lib/utils";

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1); // 1: email, 2: otp, 3: success , 4:login page
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleSendEmail = async () => {
    if (!email || !email.includes('@')) {
      openNotificationWithIcon("error", "Please enter a valid email address");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/forget`, { email }, HEADER_OPTIONS);
      
      console.log(response.data);
      if(response.data.success){
      setEmailSent(true);
        setMessage(response.data.message);
        openNotificationWithIcon(
          "success",
          "OTP successfully sent to the email address.Please Check your email"
        );
        setStep(2);
      }else{
        openNotificationWithIcon("error", response.data.message);
      }
    } catch (error) {
      if (error.response) {
        openNotificationWithIcon("error", error.response.data.message);
        setMessage(error.response.data.message);
      } else if (error.request) {
        openNotificationWithIcon("error", "No internet connection!");
      } else {
        openNotificationWithIcon("error", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setIsLoading(true);
    try{
    const response = await axios.post(`${BASE_URL}/verifyOtp`, { otp, email }, HEADER_OPTIONS);
    console.log(response.data.success);
    if(response.data.success){
        setStep(3);
        setMessage("OTP verified successfully! You can now reset your password.");
    }else{
        openNotificationWithIcon("error", response.data.message);
    }
    if (!otp || otp.length < 6) {
      openNotificationWithIcon("error", "Please enter a valid OTP");
      return;
    }

    }
    catch (error) {
      openNotificationWithIcon("error", "Invalid OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if(newPassword !== confirmPassword){
        openNotificationWithIcon("error", "Passwords do not match");
        return;
    }
    const response = await axios.post(`${BASE_URL}/reset`, { password: newPassword, email }, HEADER_OPTIONS);
    console.log("Reset Password");
    if(response.data){
        openNotificationWithIcon("success", "Password reset successful! You can now login with your new password.");
        setStep(4);
        setMessage('')
    }else{
        openNotificationWithIcon("error", response.data.message);
    }
  };

  return (
    <div className="forget-password-container">
      <style type="text/css">
        {`
          .forget-password-container {
            min-height: 100vh;
             background-color: red;
            min-height: 100vh;
            min-width: 100vw;
            background-image: url('/img/background.jpg');
            background-size: 120vw;
            display: flex;
            opacity: 0.7;
            align-items: center;
            justify-content: center;
            padding: 20px;
          }

          .forget-password-card {
            background: linear-gradient( rgba(0, 255, 204,0.5),rgba(0, 204, 102, 1));
            backdrop-filter: blur(10px);
            border-radius: 20px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            max-width: 450px;
            width: 100%;
            padding: 40px;
          }

          .forget-password-header {
            text-align: center;
            margin-bottom: 30px;
          }

          .forget-password-title {
            color: black;
            font-size: 2rem;
            font-weight: 700;
            margin-bottom: 10px;
          }

          .forget-password-subtitle {
            color: black;
            font-size: 1rem;
            margin-bottom: 0;
          }

          .form-group {
            margin-bottom: 25px;
          }

          .form-label {
            color: white;
            letter-spacing: 1px;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 0.95rem;
            margin-bottom: 8px;
          }

          .form-control {
            border-radius: 12px;
            border: 2px solid #e9ecef;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }

          .form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }

          .btn-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            border-radius: 12px;
            padding: 12px 30px;
            font-weight: 600;
            font-size: 1rem;
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 10px;
          }

          .btn-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
          }

          .btn-secondary {
            background: #6c757d;
            border: none;
            border-radius: 12px;
            padding: 12px 30px;
            font-weight: 600;
            font-size: 1rem;
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 10px;
          }

          .btn-secondary:hover {
            background: #5a6268;
            transform: translateY(-2px);
          }

          .alert {
            border-radius: 12px;
            border: none;
            margin-bottom: 20px;
          }

          .step-indicator {
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
          }

          .step {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            margin: 0 10px;
            transition: all 0.3s ease;
          }

          .step.active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }

          .step.completed {
            background: #28a745;
            color: white;
          }

          .step.pending {
            background: #e9ecef;
            color: #6c757d;
          }

          .back-link {
            text-align: center;
            margin-top: 20px;
          }

          .back-link a {
            color: #667eea;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.3s ease;
          }

          .back-link a:hover {
            color: #764ba2;
            text-decoration: underline;
          }

          .loading-spinner {
            margin-right: 8px;
          }
        `}
      </style>

      <Card className="forget-password-card">
        <div className="forget-password-header">
          <h1 className="forget-password-title">Reset Password</h1>
          
          <p className="forget-password-subtitle">
            {step === 1 && "Enter your email to receive a reset link"}
            {step === 2 && "Enter the OTP sent to your email"}
            {step === 3 && "Password reset successful"}
          </p>
        </div>

          {step !== 4 && (
        <div className="step-indicator">
          <div className={`step ${step >= 1 ? 'active' : 'pending'}`}>1</div>
          <div className={`step ${step >= 2 ? 'active' : 'pending'}`}>2</div>
          <div className={`step ${step >= 3 ? 'active' : 'pending'}`}>3</div>
        </div>
          ) }

        {message && (
          <Alert variant={step === 3 ? "success" : "info"} className="text-center">
            {message}
          </Alert>
        )}

        {step === 1 && (
          <Form>
            <Form.Group className="form-group">
              <Form.Label className="form-label">Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control"
                disabled={isLoading}
              />
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleSendEmail}
              disabled={isLoading || !email}
              className="btn-primary"
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="loading-spinner"
                  />
                  Sending...
                </>
              ) : (
                "Send Code"
              )}
            </Button>
          </Form>
        )}

        {step === 2 && (
          <Form>
            <Form.Group className="form-group">
              <Form.Label className="form-label">OTP Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter the 6-digit OTP"
                value={otp}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setOtp(value);
                }}
                className="form-control"
                disabled={isLoading}
                maxLength={6}
              />
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleVerifyOtp}
              disabled={isLoading || !otp}
              className="btn-primary"
            >

              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="loading-spinner"
                  />
                  Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </Button>

            <Button
              variant="secondary"
              onClick={() => 
                {setStep(1);
                  setMessage("")
                }
              }
              className="btn-secondary"
              style={{ marginTop: '10px' }}
            >
              Back to Email
            </Button>
          </Form>
        )}

        {
            step === 3 && (
                <Form>
                    <Form.Group controlId="newPasswordForm">
                        <Form.Label className={"login-label"}>Enter New Password</Form.Label>
                        <Form.Control type="password" placeholder="Please enter new password" name={'newPassword'} value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
                    </Form.Group>
                    <Form.Group controlId="confirmPasswordForm">
                        <Form.Label className={"login-label"}>Confirm New Password</Form.Label>
                        <Form.Control type="password" placeholder="Please enter new password" name={'confirmPassword'} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
                    </Form.Group>
                    <Button variant="primary" onClick={handleResetPassword}>Submit</Button>
                </Form>
            )
        }
        {step === 4 && (
          <div className="text-center">
            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>✅</div>
            <h4 style={{ color: 'white', marginBottom: '20px' }}>Success!</h4>
            <p style={{ color: 'black', marginBottom: '30px' }}>
              Your password has been reset successfully. You can now login with your new password.
            </p>
            <Button
              variant="primary"
              href="/"
              className="btn-primary"
            >
              Go to Login
            </Button>
          </div>
        )}

  {step !== 4 && (
        <div className="back-link">
          <a href="/">← Back to Login</a>
        </div>)}
      </Card>
    </div>
  );
};

export default ForgetPassword;
